import Vue from 'vue'
import App from '@/App.vue'
import vuetify from '@/plugins/vuetify'
import router from '@/router/index.js'
import store from '@/store'

const firebase = require('@/firebaseConfig.js')

Vue.config.productionTip = false
let app
// handle page reload
firebase.auth.onAuthStateChanged((user) => {
  if (user) {
    store.commit('SET_CURRENT_USER', user)
    store.commit('SET_AUTHENTICATED', true)
    store.dispatch('fetchUserProfile').then(() => {
      let unsubscribe = firebase.usersCollection
        .doc(store.getters.currentUser.uid)
        .collection('todos')
        .orderBy('createdAt', 'desc')
        .onSnapshot((querySnapshot) => {
          let todosArray = []
          querySnapshot.forEach((doc) => {
            let todo = doc.data()
            todo.id = doc.id
            todosArray.push(todo)
          })

          store.commit('SET_TODOS', todosArray)
        })
      store.commit('SET_LISTENER_UNSUBSCRIBE', unsubscribe)
    })
  }
})

firebase.auth.onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      router,
      vuetify,
      store,
      render: (h) => h(App),
    }).$mount('#app')
  }
})
